// eslint-disable-next-line css-modules/no-unused-class
import { EventDateBadgeOutput } from '../util/eventCalendarDateBadge';
import styles from './DateBadge.module.css';
import { DotIndicator } from './Forms/DotIndicator';
export const DateBadge: React.FC<{ eventDateBadge: EventDateBadgeOutput }> = ({ eventDateBadge }) => {
	return (
		<>
			{eventDateBadge && (
				<div className={styles.eventBadgeContainer}>
					<div className={styles.eventDotIndicator}>
						<DotIndicator />
					</div>
					<div>
						<div className={styles.month}>{eventDateBadge.month}</div>
						<div className={styles.day}>{eventDateBadge.day}</div>
						<div className={styles.dayOfWeek}>{eventDateBadge.dayOfWeek}</div>
					</div>
				</div>
			)}
		</>
	);
};
